var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApShareEnableIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_64868_23327)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 11.7615,
    width: 21,
    height: 11.2615,
    rx: 5.63073,
    transform: "rotate(180 25.5 11.7615)",
    fill: "#E99210",
    stroke: "#FAD47F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_64868_23327)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5008,
    cy: 6.1299,
    rx: 3.3,
    ry: 3.67844,
    transform: "rotate(180 20.5008 6.1299)",
    fill: "#FAD47F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5008,
    cy: 6.1299,
    rx: 3.3,
    ry: 3.67844,
    transform: "rotate(180 20.5008 6.1299)",
    stroke: "#404040"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApShareEnableIcon);
export default __webpack_public_path__ + "static/media/apShareEnableIcon.b5af8dbce59537c2ac0495deb2a26a6e.svg";
export { ForwardRef as ReactComponent };